import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Space,
  Switch,
} from "antd";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function SubscriptionCampusesModal({
  open = false,
  onCancel = () => {},
  data = {},
  onDataUpdated = () => {},
  onAllDataUpdated = () => {},
}) {
  const [form] = Form.useForm();

  const onFinish = async (updatedData) => {
    let campusesObj = data.campuses.reduce((obj, item) => {
      obj[item.campus_id] = item;
      return obj;
    }, {});
    let campusesData = updatedData.campuses.map((item) => {
      campusesObj[item.campus_id].is_active = item.is_active;
      delete item.name;
      return item;
    });

    const res = await apiRequest({
      path: apiPaths.campusSubscriptionPlans,
      method: "PUT",
      data: { campuses: campusesData },
    });
    if (!res.error) {
      onDataUpdated({ ...data, campuses: Object.values(campusesObj) });
    } else {
      message.error(res.error_description);
    }
  };

  const handleAddAll = async () => {
    const res = await apiRequest({
      path: apiPaths.campusSubscriptionPlans + `/${data.id}/all`,
      method: "POST",
    });
    if (!res.error) {
      onAllDataUpdated();
    } else {
      message.error(res.error_description);
    }
  };

  return (
    <Modal
      title={"Update Campus Subscription Plan state"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      {!data.campuses?.length ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ marginBottom: 10 }}>
            Add Subscription plans to all Campuses
          </div>
          <Button onClick={handleAddAll}>Add All</Button>
        </div>
      ) : (
        <Form
          name="campuses"
          onFinish={onFinish}
          initialValues={{
            campuses: data.campuses.map((campus) => ({
              name: campus.campus.name,
              is_active: campus.is_active,
              campus_id: campus.campus_id,
              subscription_id: campus.subscription_id,
            })),
          }}
          form={form}
          autoComplete="off"
        >
          <Row style={{ marginBottom: 10, fontWeight: "bold" }}>
            <Col span={18} style={{ paddingLeft: 10 }}>
              Campus
            </Col>
            <Col span={6}>Is Active</Col>
          </Row>
          <Form.List name="campuses">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Row
                    key={key}
                    style={{
                      marginBottom: 8,
                    }}
                  >
                    <Col span={18}>
                      <Form.Item {...restField} name={[name, "name"]}>
                        <Input
                          placeholder="First Name"
                          disabled
                          style={{
                            border: "none",
                            backgroundColor: "#fff",
                            color: "#000",
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, "is_active"]}
                        valuePropName="checked"
                      >
                        <Switch />
                      </Form.Item>
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </Form.List>
          <Form.Item>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,
              }}
            >
              <Space>
                <Button onClick={onCancel}>Cancel</Button>
                <Popconfirm
                  onConfirm={() => {
                    form.submit();
                  }}
                  title="Are you sure, This will update the active state of subscription for each campus as selected?"
                >
                  <Button type="primary">Update</Button>
                </Popconfirm>
              </Space>
            </div>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
}

export default SubscriptionCampusesModal;
